<template>
    <div>
        <div class="page_top">
            <div class="title">
                <i class="icon" id="icon" @click="back()"></i>
                <span class="header-text">{{ this.title }}</span>
            </div>
        </div>
        <div class="container mt-4 scrollable-container" v-loading.fullscreen="is_loading"
             element-loading-background="rgba(0, 0, 0, 0.5)">
            <!-- 注意事項 -->
            <el-card class="mb-4" shadow="always" style="border-color: #909399">
                <span class="fw-bold fs-5">注意事項</span>
                <div class="text-muted mt-2">
                    <p class="mb-1">1.價格不包含代收費用</p>
                    <p class="mb-1">2.報價後期限內付款完成才成算成立</p>
                    <p class="mb-1">3.尾款於託運後收取，包含代收費費用</p>
                </div>

            </el-card>
            <!-- 運輸資訊 -->
            <el-card class="mb-4" shadow="always" style="border-color: #909399">
                <span class="fs-5 fw-bold">運輸資訊</span>
                <el-form :model="order" :rules="rules" ref="startDateForm" label-position="top">
                    <!-- 啟運日 -->
                    <el-form-item class="form-label-lg" prop="start_date">
                        <template #label>
                            <i class="el-icon-date" style="margin-left: 5px;"></i> 啟運日
                        </template>
                        <el-date-picker
                            v-model="order.start_date"
                            type="date"
                            :picker-options="{
                                                disabledDate(time) {
                                                    return time.getTime() < Date.now() - 86400000;
                                                }
                                            }"
                            placeholder="選擇日期"
                            prefix-icon="el-icon-date"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <el-form :model="transportInfo" :rules="rules" ref="transportForm" label-position="top">
                    <!-- 啟運地 -->
                    <el-form-item label="啟運地" class="form-label-lg">
                        <!-- 地標 -->
                        <el-form-item prop="origin.landmark">
                            <el-input v-model="transportInfo.origin.landmark"
                                      placeholder="請輸入地標，例如:高雄軟體園區"></el-input>
                        </el-form-item>
                        <!-- 縣市 -->
                        <el-form-item prop="origin.city">
                            <el-select v-model="transportInfo.origin.city" placeholder="縣市" class="mt-2"
                                       @change="getOriginTowns">
                                <el-option v-for="county in counties" :key="county.id" :label="county.text"
                                           :value="county.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 區域選擇 -->
                        <el-form-item prop="origin.district">
                            <el-select v-model="transportInfo.origin.district" placeholder="區" class="mt-2">
                                <el-option v-for="town in originTowns" :key="town.id" :label="town.text"
                                           :value="town.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 地址 -->
                        <el-form-item prop="origin.address">
                            <el-input v-model="transportInfo.origin.address" placeholder="地址" class="mt-2"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <!-- 送達地 -->
                    <el-form-item label="送達地" class="form-label-lg">
                        <!-- 地標 -->
                        <el-form-item prop="destination.landmark">
                            <el-input v-model="transportInfo.destination.landmark"
                                      placeholder="請輸入地標，例如:高雄軟體園區"></el-input>
                        </el-form-item>
                        <!-- 縣市 -->
                        <el-form-item prop="destination.city">
                            <el-select v-model="transportInfo.destination.city" placeholder="縣市" class="mt-2"
                                       @change="getDestinationTowns">
                                <el-option v-for="county in counties" :key="county.id" :label="county.text"
                                           :value="county.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 區域選擇 -->
                        <el-form-item prop="destination.district">
                            <el-select v-model="transportInfo.destination.district" placeholder="區" class="mt-2">
                                <el-option v-for="town in destinationTowns" :key="town.id" :label="town.text"
                                           :value="town.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 地址 -->
                        <el-form-item prop="destination.address">
                            <el-input v-model="transportInfo.destination.address" placeholder="地址"
                                      class="mt-2"></el-input>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </el-card>

            <!-- 貨物資訊 -->
            <el-card class="mb-4" shadow="always" style="border-color: #909399">
                <span class="fs-5 fw-bold">貨物資訊</span>
                <el-form :model="order" :rules="rules" ref="cargoForm">
                    <el-form-item class="mt-3" prop="is_dangerous">
                        <span class="me-3  fw-bold " style="font-size: 1rem;color: #F56C6C">危險物品</span>
                        <el-switch v-model="order.is_dangerous" :active-value="1" :inactive-value="0"></el-switch>
                    </el-form-item>
                    <el-form-item label="貨櫃規格" class="form-label-lg" prop="container_type_id">
                        <el-select v-model="order.container_type_id" placeholder="選擇規格">
                            <el-option v-for="type in containerTypes" :key="type.id" :label="type.name"
                                       :value="type.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="貨物名稱" class="form-label-lg" prop="title">
                        <el-input v-model="order.title" placeholder="說明"></el-input>
                    </el-form-item>
                    <el-form-item label="貨物內容說明" class="form-label-lg" prop="details">
                        <el-input v-model="order.details" type="textarea"
                                  placeholder="貨物內容說明"></el-input>
                    </el-form-item>
                    <el-form-item label="其他需求" class="form-label-lg" prop="remarks">
                        <el-input v-model="order.remarks" type="textarea" :rows="5" placeholder="其他需求"></el-input>
                    </el-form-item>
                </el-form>
            </el-card>

            <!-- 聯絡資訊 -->
            <el-card class="mb-4" shadow="always" style="border-color: #909399">
                <span class="fs-5 fw-bold">聯絡資訊</span>
                <el-form :model="order" :rules="rules" ref="contactForm">
                    <el-form-item label="公司名稱" class="form-label-lg" prop="company_name">
                        <el-input v-model="order.company_name" placeholder="公司名稱"></el-input>
                    </el-form-item>
                    <el-form-item label="聯絡人" class="form-label-lg" prop="contact_person">
                        <el-input v-model="order.contact_person" placeholder="聯絡人"></el-input>
                    </el-form-item>
                    <el-form-item label="電話" class="form-label-lg" prop="phone">
                        <el-input v-model="order.phone" placeholder="電話"></el-input>
                    </el-form-item>
                    <el-form-item label="公司統編" class="form-label-lg" prop="business_number">
                        <el-input v-model="order.business_number" placeholder="公司統編" maxlength="8"></el-input>
                    </el-form-item>
                </el-form>
            </el-card>

            <!-- 提交按鈕 -->
            <div class="text-center">
                <el-button type="primary" @click="submitForm">提交</el-button>
            </div>


        </div>
    </div>

</template>

<script>
import FN from "@/components/fn.vue";
import {ADD_SHIPMENT_ORDER} from "@/api";

export default {
    mixins: [FN],
    data() {
        return {
            title: '新增詢價',
            isEdit: false, // 判斷是否為修改模式
            counties: [], // 縣市資料
            originTowns: [], // 啟運地城鎮資料
            destinationTowns: [],// 送達地城鎮資料
            containerTypes: [],// 貨櫃規格資料
            order: {
                title: '',
                start_date: '',
                is_dangerous: '',
                container_type_id: '',
                details: '',
                remarks: '',
                company_name: '',
                contact_person: '',
                phone: '',
                business_number: '',
                locations: []
            },
            transportInfo: {
                origin: {
                    landmark: '',
                    city: '',
                    district: '',
                    address: ''
                },
                destination: {
                    landmark: '',
                    city: '',
                    district: '',
                    address: ''
                }
            },
            is_loading: false,
            rules: {
                // --- order 物件的規則 ---
                'title': [
                    {required: true, message: '請輸入訂單標題', trigger: 'blur'},
                    {min: 2, max: 50, message: '標題長度需在 2 到 50 個字元之間', trigger: 'blur'}
                ],
                'start_date': [
                    {type: 'date', required: true, message: '請選擇開始日期', trigger: 'change'}
                ],
                'is_dangerous': [
                    {required: true, message: '請選擇是否為危險品', trigger: 'change'}
                ],
                'container_type_id': [
                    {required: true, message: '請選擇櫃型', trigger: 'change'}
                ],
                'details': [
                    {required: true, message: '請輸入訂單詳情', trigger: 'blur'},
                    {min: 5, max: 500, message: '詳情長度需在 5 到 500 個字元之間', trigger: 'blur'}
                ],
                'remarks': [
                    {max: 200, message: '備註長度不可超過 200 個字元', trigger: 'blur'} // 可選填，但有長度限制
                ],
                'company_name': [
                    {required: true, message: '請輸入公司名稱', trigger: 'blur'},
                    {min: 2, max: 100, message: '公司名稱長度需在 2 到 100 個字元之間', trigger: 'blur'}
                ],
                'contact_person': [
                    {required: true, message: '請輸入聯絡人姓名', trigger: 'blur'},
                    {min: 2, max: 50, message: '聯絡人姓名長度需在 2 到 50 個字元之間', trigger: 'blur'}
                ],
                'phone': [
                    {required: true, message: '請輸入聯絡電話', trigger: 'blur'},
                    {pattern: /^[0-9-()#]+$/, message: '請輸入有效的電話號碼', trigger: 'blur'}, // 允許數字、-、()、#
                    {min: 9, max: 20, message: '電話號碼長度需在 9 到 20 個字元之間', trigger: 'blur'}
                ],
                'business_number': [
                    {pattern: /^[0-9-()#]+$/, message: '請輸入有效的號碼', trigger: 'blur'}, // 允許數字、-、()、#
                    {min: 8, max: 8, message: '公司統編需要 8 個數字', trigger: 'blur'}
                ],

                // --- transportInfo 物件的規則 ---
                // 起點 (origin)
                'origin.landmark': [
                    {
                        required: true,
                        max: 100,
                        message: '請輸入起點地標，起點地標長度不可超過 100 個字元',
                        trigger: 'blur'
                    }
                ],
                'origin.city': [
                    {required: true, message: '請選擇起點城市', trigger: 'change'}
                ],
                'origin.district': [
                    {required: true, message: '請選擇起點區域', trigger: 'change'}
                ],
                'origin.address': [
                    {required: true, message: '請輸入起點詳細地址', trigger: 'blur'},
                    {min: 5, max: 200, message: '起點地址長度需在 5 到 200 個字元之間', trigger: 'blur'}
                ],

                // 終點 (destination)
                'destination.landmark': [
                    {
                        required: true,
                        max: 100,
                        message: '請輸入終點地標，終點地標長度不可超過 100 個字元',
                        trigger: 'blur'
                    }
                ],
                'destination.city': [
                    {required: true, message: '請選擇終點城市', trigger: 'change'}
                ],
                'destination.district': [
                    {required: true, message: '請選擇終點區域', trigger: 'change'}
                ],
                'destination.address': [
                    {required: true, message: '請輸入終點詳細地址', trigger: 'blur'},
                    {min: 5, max: 200, message: '終點地址長度需在 5 到 200 個字元之間', trigger: 'blur'}
                ]
            }
        };
    },
    methods: {
        /**
         * 返回上一頁
         */
        back() {
            this.$router.go(-1)
        },
        submitForm() {
            Promise.all([
                new Promise(resolve => this.$refs.startDateForm.validate(resolve)),
                new Promise(resolve => this.$refs.transportForm.validate(resolve)),
                new Promise(resolve => this.$refs.cargoForm.validate(resolve)),
                new Promise(resolve => this.$refs.contactForm.validate(resolve))
            ]).then(([valid1, valid2, valid3, valid4]) => {
                if (valid1 && valid2 && valid3 && valid4) {
                    this.integrateTransportInfo();
                    if (this.isEdit) {
                        this.editOrders();
                        // this.$notify({
                        //     title: '修改成功',
                        //     message: '詢價已成功修改。',
                        //     type: 'success'
                        // });
                        // this.$router.push('/container');
                    } else {
                        this.addOrders();
                    }
                } else {
                    this.$notify({
                        title: '資料有誤',
                        message: '請檢查資料是否正確。',
                        type: 'warning'
                    });
                }
            });
        },
        /**
         * 獲取修改數據
         */
        fetchEditData(id) {
            this.is_loading = true;
            this.FETCH({
                key: 'GET_SHIPMENT_ORDER_DETAIL',
                id: id,
            })
                .then((res) => {
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getChannel)
                    } else if (+(res || {}).code === 0) {
                        res.data.start_date = new Date(res.data.start_date);
                        this.order = res.data;
                        this.setTransportInfoFromLocations(res.data.locations);
                        this.getTowns();
                        this.is_loading = false;

                    } else {
                        this.$notify({
                            title: '資料異常',
                            message: '請稍後再試。',
                            type: 'warning'
                        });
                        this.is_loading = false;
                        this.$router.push('/container'); // 跳轉到詢價列表頁面

                    }
                })
                .catch((err) => {
                    this.$router.push('/container'); // 跳轉到詢價列表頁面
                });
            // 模擬 API 請求
            console.log(`正在獲取 ID 為 ${id} 的數據`);

        },
        /**
         *  獲取最新聯絡人資訊
         */
        fetchLastContactInfo() {
            this.FETCH({
                key: 'GET_LAST_SHIPMENT_CONTACT',
            })
                .then((res) => {
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getChannel)
                    } else if (+(res || {}).code === 0) {
                        this.order.company_name = res.data.company_name;
                        this.order.contact_person = res.data.contact_person;
                        this.order.phone = res.data.phone;
                        this.order.business_number = res.data.business_number;
                    }
                });
        },
        /**
         * 取得城市資料
         */
        getCounties() {
            this.FETCH({
                key: 'GET_COUNRIES',
            }).then((res) => {
                this.counties = res;
            });
        },
        /**
         * 取得城市資料
         */
        getOriginTowns() {
            if (!this.transportInfo.origin.city) {
                this.originTowns = [];
                return;
            }
            this.FETCH({
                key: 'GET_TOWNS',
                q: this.transportInfo.origin.city
            }).then((res) => {
                this.originTowns = res;
            });
        },
        /**
         * 取得目的地城鎮資料
         */
        getDestinationTowns() {
            if (!this.transportInfo.destination.city) {
                this.destinationTowns = [];
                return;
            }
            this.FETCH({
                key: 'GET_TOWNS',
                q: this.transportInfo.destination.city
            }).then((res) => {
                this.destinationTowns = res;
            });
        },
        /**
         * 取得所有城鎮資料
         */
        getTowns() {
            this.getOriginTowns();
            this.getDestinationTowns();
        },
        /**
         * 取得貨物規格
         */
        fetchContainerTypes() {
            this.FETCH({
                key: 'GET_CONTAINER_TYPES',
            }).then((res) => {
                this.containerTypes = res.data;
            });
        },
        /**
         * 將 transportInfo 的資料整合到 order.locations 中
         */
        integrateTransportInfo() {
            this.order.locations = [
                {
                    county_id: this.transportInfo.origin.city,
                    town_id: this.transportInfo.origin.district,
                    name: this.transportInfo.origin.landmark,
                    address: this.transportInfo.origin.address,
                    location_type: 1, // 啟運地
                },
                {
                    county_id: this.transportInfo.destination.city,
                    town_id: this.transportInfo.destination.district,
                    name: this.transportInfo.destination.landmark,
                    address: this.transportInfo.destination.address,
                    location_type: 2, // 送達地
                }
            ];
        },
        /**
         * 新增訂單
         */
        addOrders() {
            this.is_loading = true;
            this.integrateTransportInfo();
            this.FETCH({
                key: 'ADD_SHIPMENT_ORDER',
                ...this.order
            })
                .then((res) => {
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getChannel)
                    } else if (+(res || {}).code === 0) {
                        this.$notify({
                            title: '新增成功',
                            message: '詢價已成功新增。',
                            type: 'success'
                        });
                        this.$router.push('/container'); // 跳轉到詢價列表頁面
                    } else {
                        this.$notify({
                            title: '新增失敗',
                            message: res.message || '請稍後再試。',
                            type: 'warning'
                        });
                        console.log(this.is_loading);
                        this.is_loading = false;
                    }
                })
                .catch((err) => {
                    this.is_loading = false;
                });
        },
        /**
         * 根據 locations 設定 transportInfo
         * @param {Array} locations - 包含啟運地和送達地的位置信息
         */
        setTransportInfoFromLocations(locations) {
            this.transportInfo = {
                origin: {
                    landmark: locations?.find(l => l.location_type === 1)?.name || '',
                    city: locations?.find(l => l.location_type === 1)?.county_id || '',
                    district: locations?.find(l => l.location_type === 1)?.town_id || '',
                    address: locations?.find(l => l.location_type === 1)?.address || ''
                },
                destination: {
                    landmark: locations?.find(l => l.location_type === 2)?.name || '',
                    city: locations?.find(l => l.location_type === 2)?.county_id || '',
                    district: locations?.find(l => l.location_type === 2)?.town_id || '',
                    address: locations?.find(l => l.location_type === 2)?.address || ''
                }
            };
        },
        /**
         * 編輯訂單
         */
        editOrders() {
            this.is_loading = true;
            this.integrateTransportInfo();
            this.FETCH({
                key: 'EDIT_SHIPMENT_ORDER',
                ...this.order
            })
                .then((res) => {
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getChannel)
                    } else if (+(res || {}).code === 0) {
                        this.$notify({
                            title: '修改成功',
                            message: '詢價已成功修改。',
                            type: 'success'
                        });
                        this.$router.push('/container'); // 跳轉到詢價列表頁面
                    } else {
                        this.$notify({
                            title: '修改失敗',
                            message: res.message || '請稍後再試。',
                            type: 'warning'
                        });
                        console.log(this.is_loading);
                        this.is_loading = false;
                    }
                })
                .catch((err) => {
                    this.is_loading = false;
                });
        },

    },
    mounted() {
        this.getCounties();
        this.fetchContainerTypes();
        // 根據路由參數判斷是新增還是修改
        const id = this.$route.params.id;
        if (id) {
            this.isEdit = true;
            this.title = '修改詢價',
                this.fetchEditData(id); // 如果是修改，調用 API 獲取數據
        } else {
            this.title = '新增詢價',
                /** 如果是新增，則獲取最新聯絡人資訊 */
                this.fetchLastContactInfo();
        }

    },

};
</script>

<style>

.scrollable-container {
    max-height: 85vh; /* 設置最大高度 */
    overflow-y: auto; /* 啟用垂直滾動條 */
}

.form-label-lg .el-form-item__label {
    font-size: 1rem; /* 約 20px */
    font-weight: 500;
}

.danger .el-form-item__label {
    color: #F56C6C;
}

.el-form-item.is-error .el-form-item__error {
    /* 這是錯誤訊息的 CSS 類名，確保它沒有被絕對定位或負邊距 */
    position: relative; /* 確保它在正常的文檔流中 */
    margin-top: 5px; /* 增加與輸入框的距離 */
    line-height: 1.2; /* 調整行高以防文字太擠 */
}

</style>
